import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { fmtDate } from "./ui-kit";
import { ShieldCheck, ShieldAlert, ShieldQuestion, Clock } from "lucide-react";

const TONE = {
  active: ["border-primary/40 bg-[#DEF1E5] text-primary", ShieldCheck, "Authorization active"],
  expiring: ["border-[#91661E]/50 bg-amber-50 text-[#91661E]", Clock, "Authorization expiring"],
  expired: ["border-[#A4473C]/50 bg-red-50 text-[#A4473C]", ShieldAlert, "Authorization expired"],
  pending: ["border-border bg-muted text-foreground", ShieldQuestion, "Authorization not yet approved"],
  none: ["border-border bg-muted text-muted-foreground", ShieldQuestion, "No authorization on file"],
};

export function AuthStrip({ clientId, on, compact }) {
  const [a, setA] = useState(null);
  useEffect(() => { if (clientId) api.get(`/clients/${clientId}/auth-strip`, { params: on ? { on } : {} }).then((r) => setA(r.data)).catch(() => setA({ state: "none" })); }, [clientId, on]);
  if (!a) return null;
  const [cls, Icon, label] = TONE[a.state] || TONE.none;
  const missing = (a.renewal_needs || []).filter((n) => !n.available);
  return (
    <div className={`flex flex-wrap items-center gap-x-4 gap-y-1 rounded-2xl border-2 px-4 py-2.5 ${cls}`} data-testid="auth-strip" data-state={a.state}>
      <Icon className="h-5 w-5 shrink-0" />
      <p className="text-xs font-extrabold uppercase tracking-wide">{label}</p>
      {a.state !== "none" && <>
        <span className="text-sm font-bold" data-testid="auth-strip-period">{fmtDate(a.start)} → {fmtDate(a.end)}</span>
        {a.days_remaining != null && a.state !== "expired" && <span className="text-xs font-semibold">{a.days_remaining}d left</span>}
        <span className="text-xs">{a.request_type} · Auth # {a.auth_number || "—"} · {a.units ?? "—"} units · {a.program}</span>
      </>}
      {a.renewal_needs && !compact && <span className="text-xs" data-testid="auth-strip-needs">{a.state === "none" ? "Initial auth needs" : "Renewal needs"}: {a.renewal_needs.map((n) => <span key={n.key} className={`ml-1 rounded-full px-2 py-0.5 ${n.available ? "bg-white/60 line-through opacity-70" : "bg-white font-semibold"}`}>{n.label}</span>)}{missing.length === 0 && <span className="ml-1 font-semibold">all on file</span>}</span>}
      <Link to="/app/authorizations" className="ml-auto text-xs font-semibold underline" data-testid="auth-strip-link">Authorizations</Link>
    </div>
  );
}
